
import { FC } from "react";
import { AuthenticatedLayout } from "../../layouts";
import { ChequeSettingsList } from "../../components/ChequeSettingsList";

export interface IChequeSettingsListPage {}

export const ChequeSettingsListPage: FC<IChequeSettingsListPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Cheque Settings List"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Cheque Settings", navigateTo: "/settings/cheque/list" },
      ]}
      mainContents={<ChequeSettingsList />}
    />
  );
};
